/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { mainSelector, unSaveChangesPopupSelector } from "../redux/selectors/custom-selector";
import { clearLinkedKpi, clearLinkedRules, setUnSavedChangesPopup } from "../redux/actions/setting-actions";
import { useHistory, useLocation } from "react-router-dom";
import { clearReportsState } from "src/redux/actions/reports-actions";
import { clearCompPlanReportsState } from "src/redux/actions/compplan-actions";
import { clearProviderPlanReportsState } from "src/redux/actions/providerplan-actions";
import { getUserCredential } from "src/lib/cookies";
import { socket } from "src/App";

// "events" and "event_dashboard" are the same feature; which one is the menu's
// db_obj_code depends on the PCP-495 DML, and non-dashboard users are redirected to
// the /events grid. Treat them as interchangeable so the Event item stays highlighted
// on either path regardless of the menu code.
const MENU_ACTIVE_CODE_GROUPS = [["events", "event_dashboard"]];
const getActiveMenuCodes = (code) =>
  MENU_ACTIVE_CODE_GROUPS.find((group) => group.includes(code)) || [code];

const Sidebar = () => {
  const dispatch = useDispatch();
  const cookiesData = getUserCredential();
  const location = useLocation();
  const pathName = location.pathname.substring(1);
  const activeCodes = React.useMemo(() => getActiveMenuCodes(pathName), [pathName]);
  const { dbObjData } = useSelector(mainSelector, shallowEqual);
  const { userStatusData } = useSelector((state) => state.mobileRoleReducer?.mobileRoleData || {}, shallowEqual);

  const { communicationChannelCount } = useSelector((state) => state.OTHER);
  /*
    const { unsavedPopup } = useSelector(
        unSaveChangesPopupSelector,
        shallowEqual
    );
    */
  const history = useHistory();

  const ToggleClass = (e) => {
    const targetNode = e.currentTarget;
    const parentNode = targetNode.parentNode;

    if (!parentNode.querySelector("ul li.active")) {
      parentNode.classList.toggle("active");
      targetNode.querySelector("span i").classList.toggle("fa-plus");
      targetNode.querySelector("span i").classList.toggle("fa-minus");
    }

    e.preventDefault();
  };

  const handleClick = (url, e) => {
    const thisParent = e.currentTarget.closest("ul").closest("li");
    const thisParentDataCode = thisParent.getAttribute("data-code");
    const navigation = e.currentTarget.closest("ul.navigation");

    const activeChildren = navigation.querySelectorAll("ul.child-nav > li.active");

    //remove active class from child element
    activeChildren.forEach((el) => {
      el.classList.remove("active");
    });

    const parentList = navigation.querySelectorAll("li[data-code]:not([data-code='" + thisParentDataCode + "'])");

    //remove active class from parent element
    parentList.forEach((el) => {
      el.classList.remove("active");

      const icon = el.querySelector("span i");

      if (icon) {
        icon.classList.remove("fa-minus");
        icon.classList.add("fa-plus");
      }
    });

    const thisChild = e.currentTarget.closest("li");
    thisChild.classList.add("active");

    e.preventDefault();

    dispatch(clearLinkedRules());
    dispatch(clearLinkedKpi(""));

    /*
        if (unsavedPopup.isUnSavedChange) {
            dispatch(
                setUnSavedChangesPopup({
                    ...unsavedPopup,
                    isVisible: true,
                    callbackFn: () => {
                        history.push(url);
                    },
                })
            );
        } else {
         */
    history.push(url);
    /*
        if (pathName === "specialty" && url === "specialty") {
            history.go(0);
        }
        */
    //}
  };
  const [isHovered, setIsHovered] = useState(false);

  const renderMenu = useCallback(() => {
    return (
      <ul className="navigation">
        {dbObjData.map(({ db_obj_name, db_obj_key, db_obj_code, is_active, children: subMenu, ...rest }) => (
          <li
            key={db_obj_key}
            data-code={db_obj_code}
            className={subMenu?.find((elem) => elem.db_obj_code === pathName) ? "active" : ""}
          >
            <a
              className="cursor-pointer"
              onClick={(e) => {
                if (subMenu?.length > 0 && !subMenu.find((elem) => elem.db_obj_code === "messages")) {
                  ToggleClass(e);
                } else {
                  history.push("/" + db_obj_code);
                }
              }}
            >
              <i className={"fas nav_icon_" + db_obj_code}></i>{" "}
              <span>
                {db_obj_name}

                {/* SHOW UNREAD COUNT */}
                {db_obj_code === "communication_channel" && (
                  <span
                    className="message-count"
                    style={{
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                      backgroundColor: "#00a1e4",
                      color: "#fff",
                      fontSize: "0.6rem",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      marginLeft: "20px",
                    }}
                  >
                    {communicationChannelCount}
                  </span>
                )}

                {/* SHOW +/- ONLY IF CHILD EXISTS */}
                {subMenu?.length > 0 && db_obj_code !== "communication_channel" && (
                  <i
                    className={subMenu.find((elem) => elem.db_obj_code === pathName) ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                )}
              </span>
            </a>
            {Array.isArray(subMenu) ? (
              <ul className="child-nav">
                {subMenu
                  .filter((childDbObj) => childDbObj.db_obj_code !== "messages")
                  .map((childDbObj) => (
                    <li
                      key={childDbObj.db_obj_key}
                      id={"nav_" + childDbObj.db_obj_code}
                      className={childDbObj.db_obj_code === pathName ? "pointer-class active" : "pointer-class"}
                    >
                      <a
                        className="cursor-pointer"
                        onClick={(e) => {
                          if (db_obj_code !== "reports") {
                            dispatch(clearReportsState());
                            dispatch(clearCompPlanReportsState());
                            dispatch(clearProviderPlanReportsState());
                          }
                          handleClick(childDbObj.db_obj_code, e);
                        }}
                      >
                        <i className={"fas nav_icon_" + childDbObj.db_obj_code}></i>{" "}
                        <span>{childDbObj.db_obj_name}</span>{" "}
                      </a>
                    </li>
                  ))}
              </ul>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }, [dbObjData, pathName, userStatusData, communicationChannelCount]);

  useEffect(() => {
    console.log("Cookies Data:", cookiesData);
    if (!socket || !cookiesData?.out_user_id) return;

    const userId = cookiesData.out_user_id;

    const registerUserRoom = () => {
      console.log("Registering room:", userId);

      socket.emit("message-register-user", userId);
    };

    const onReceiveMessage = (data) => {
      console.log("UNREAD_MESSAGE received:", data);

      const unread = data?.row_result?.[0]?.total_unread_count || 0;
      // console.log("Updating Emitted MESSAGE_SEEN ", data?.row_result?.[0].total_unread_count,communicationChannelCount?.isCurrent);
      // if(!communicationChannelCountcommunicationChannelCount?.isCurrent){
      //   dispatch(changeMessageCount({isCurrent: false, count: unread}));
      //   // setUnreadCount(unread);
      // }
      // setUnreadCount(unread);
    };

    const onMessageSeen = (data) => {
      console.log("MESSAGE_SEEN received:", data);

      // Reset sidebar unread count
      // setUnreadCount(0);
    };

    // if already connected
    if (socket.connected) {
      registerUserRoom();
    }

    socket.on("connect", registerUserRoom);

    console.log("Setting up UNREAD_MESSAGE listener", socket);

    socket.on("UNREAD_MESSAGE", onReceiveMessage);
    socket.on("MESSAGE_SEEN", onMessageSeen);
    return () => {
      socket.off("connect", registerUserRoom);
      socket.off("UNREAD_MESSAGE", onReceiveMessage);
    };
  }, [socket, cookiesData?.out_user_id]);

  return (
    <div className="container">
      <nav
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`NavContainer ${isHovered ? "Hover" : ""}`}
      >
        <div className="desktop-logo">
          <a>
            <img src={require("../images/menu-icon.svg").default} alt="ProCARE" />{" "}
          </a>
          <a className="close" href="javascript.void(0);">
            <i className="fas fa-times"></i>
          </a>
        </div>
        {renderMenu()}
      </nav>
    </div>
  );
};

export default React.memo(Sidebar);